module.exports = __webpack_public_path__ + "static/media/hindsightHero.71ab9502.png";